export const AuthType = [
    "None",
    "Guest Android",
    "Guest Ios",
    "Facebook",
    "Apple",
    "Mail",
    "Gmail",
    "Bot"
];